<template>
  <div
    class="adviseHeader callout callout-default"
    @click="$emit('threadSelected')"
  >
    <small
      v-if="advise.completed"
      class="pull-right badge badge-info"
    > {{ trans('core.closed') }} </small>
    <template v-if="subscribable != null">
      <span
        class="text-muted"
        style="font-size: 14px;"
      >{{ subscribable.name }}</span> <br>
    </template>
    <small class="text-muted"> {{ advise.employee }}</small> - <small class="text-muted"> {{ advise.student }}</small> <br>
    <small class="text-muted"> {{ advise.messages.length || 0 }} {{ trans_choice('subscription.messages', advise.messages.length || 0) }}</small> <br>
  </div>
</template>

<script>

import Loader from '@/employees/components/Loader'
export default {
  name: 'AdviseThreadHeader',
  components: { Loader },
  props: {
    advise: {
      required: true,
    },
    subscribable: {
      required: false,
      default: null,
    },
  },
  data () {
    return {
    }
  },

}

</script>

<style scoped lang="scss">
.adviseHeader{
  margin-bottom:10px;
  border-right: 1px solid #eee;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
</style>
